// import { initializeApp } from "firebase";
// import firebase from 'firebase/compat/app'
// import { getDatabase} from "firebase/database";

// const firebaseConfig = {
//   apiKey: "AIzaSyBZc-pTEQnBCV8jZTNt-y-KsxEbyZMNB0c",
//   authDomain: "wisdomnet-1683f.firebaseapp.com",
//   databaseURL: "https://wisdomnet-1683f-default-rtdb.firebaseio.com",
//   projectId: "wisdomnet-1683f",
//   storageBucket: "wisdomnet-1683f.appspot.com",
//   messagingSenderId: "373192466408",
//   appId: "1:373192466408:web:a1295bf9487cd1f0f20e5d",
//   measurementId: "G-ML73YYG2RL"
// };
// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);

// const db = getDatabase(firebase)
//  export default firebase


 import firebase from "firebase";

 const firebaseConfig = {
  databaseURL: "https://coacherly-fd948-default-rtdb.europe-west1.firebasedatabase.app",
  apiKey: "AIzaSyBgaXVnVYBQd4lgEp2u1iJLYE8emq2GVuk",
  authDomain: "coacherly-fd948.firebaseapp.com",
  projectId: "coacherly-fd948",
  storageBucket: "coacherly-fd948.appspot.com",
  messagingSenderId: "86328675444",
  appId: "1:86328675444:web:5ae1f91ca45657cbe15521",
  measurementId: "G-K8GVMKY8R8"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;


// WEBPACK FOOTER //
// ./src/helpers/firebase.config.js